import { History } from '@mui/icons-material';
import { Button } from '@mui/material';
import { FC, useState } from 'react';
import { InvoiceHistoryDialog } from './InvoiceHistoryDialog';

export interface IInvoiceHistoryButtonProps {
    orderReviewId?: string;
    size?: 'small' | 'medium' | 'large';
    disabled?: boolean;
};

export const InvoiceHistoryButton: FC<IInvoiceHistoryButtonProps> = ({ orderReviewId, size, disabled }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleClick = () => setIsOpen(true);

    return (
        <>
            <Button variant='contained' onClick={handleClick} startIcon={<History />} size={size} disabled={disabled}>
                Invoice History
            </Button>
            <InvoiceHistoryDialog open={isOpen} onClose={() => setIsOpen(false)} orderReviewId={orderReviewId} />
        </>
    );
};